import { Action } from '@ngrx/store';
import { GuidanceAndAdvice } from 'src/app/model/ngrx/guidance-and-advice.model';
import * as GuidanceAndAdviceActions from '../actions/guidance-and-advice.actions';
export type Actions = GuidanceAndAdviceActions.Actions;
export function GuidanceAndAdviceReducer(state: GuidanceAndAdvice[] = [], action: GuidanceAndAdviceActions.Actions) {
    switch (action.type) {
        case GuidanceAndAdviceActions.ADD_GUIDANCE_AND_ADVICE:
            return [...state, action.payload];
        // Add this case:
        case GuidanceAndAdviceActions.REMOVE_GUIDANCE_AND_ADVICE:
            state = [];
            return state;
        default:
            return state;
    }
}

